import { render } from "./ModalNewGlobal.vue?vue&type=template&id=2cd3c97a"
import script from "./ModalNewGlobal.vue?vue&type=script&lang=js"
export * from "./ModalNewGlobal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__